import { loadGoogleMapsLibraries } from './googleMapsLoader'

const splitDescription = (description = '') => {
  const parts = description
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)

  const [mainText = description, ...secondaryParts] = parts

  return {
    mainText,
    secondaryText: secondaryParts.join(', ').replace(/,\s*Canada$/i, ''),
  }
}

const getMatchedSubstrings = (text = '', input = '') => {
  const query = input.trim().toLowerCase()

  if (!query) return []

  const offset = text.toLowerCase().indexOf(query)

  return offset === -1 ? [] : [{ offset, length: query.length }]
}

export const normalizePlacePrediction = (placePrediction, input = '') => {
  const description = placePrediction?.text?.toString?.() || ''
  const { mainText, secondaryText } = splitDescription(description)

  return {
    description,
    matched_substrings: [],
    placePrediction,
    place_id: placePrediction?.placeId || description,
    structured_formatting: {
      main_text: mainText,
      main_text_matched_substrings: getMatchedSubstrings(mainText, input),
      secondary_text: secondaryText,
    },
  }
}

export const fetchAutocompleteSuggestions = async ({ input, ...request }) => {
  await loadGoogleMapsLibraries(['places'])

  const { AutocompleteSuggestion } = window.google.maps.places
  const { suggestions = [] } =
    await AutocompleteSuggestion.fetchAutocompleteSuggestions({
      input,
      ...request,
    })

  return suggestions
    .map((suggestion) => normalizePlacePrediction(suggestion?.placePrediction, input))
    .filter((prediction) => Boolean(prediction.description))
}